import qs from "qs";
import UrlPattern from "url-pattern";

export const pathPattern = new UrlPattern(
    /^(?:\/([^\/]+))?\/(subprocess|process)\/([^\/]+)(?:\/(.*))*/i,
    ["base", "processType", "action", "id"]);

import { defaultAgentGroupName, defaultEnvironmentName } from "../../shared/model/AgentGroup";
import { matchPath } from "react-router";
import { processURLPatternBase } from "processEditor";
import { getProcessPath } from "processList/model/AppPath";
import { DEFAULT_ENV_NAME } from "environmentVariables/model/EnvironmentState";
import { DEFAULT_AGENT_GROUP_NAME } from "processList/actions/DeployActions";

export interface IProcessURL {
    base?: string;
    action: string;
    id: string;
    processType: string;
}

export interface ParsedPathParts {
    processType: string;
    base?: string;
    action: string;
    id?: string;
}

export interface PathParts {
    processType: ProcessType;
    base?: string;
    action: string;
    id?: string;
}

export enum ProcessType {
    Process = "Process",
    Subprocess = "Subprocess"
}

const checkIsSubprocess = (pathParts: ParsedPathParts) => {
    return pathParts && pathParts.processType &&
        pathParts.processType.toLowerCase() === ProcessType.Subprocess.toLowerCase();
};

const initialPathParts: PathParts = getPathParts();

const basePart = initialPathParts.base ? initialPathParts.base + "/" : "";
const isSubprocess = initialPathParts.processType === ProcessType.Subprocess;

function getPathParts(): PathParts {
    const location: Location = Object.assign({}, window.location);
    return getPathPartsFromUrl(location.pathname);
}

// for tests. This whole helper should probably be removed in favour of react-router
export function getPathPartsFromUrl(path: string) {
    const match: ParsedPathParts = pathPattern.match(path);
    return {
        processType: checkIsSubprocess(match) ? ProcessType.Subprocess : ProcessType.Process,
        base: match && match.base,
        action: match && match.action,
        id: match && match.id
    };
}

export function getApiManagementLink(apiSpecId: number | null) {
    return `/${basePart}ApiManagement/${defaultEnvironmentName}/${defaultAgentGroupName}/${apiSpecId}`;
}

export function getProcessListLink(processId: number) {
    return `/${basePart}${(isSubprocess ? "SubProcess" : "Process")}/List/${defaultEnvironmentName}/${defaultAgentGroupName}?highlightProcess=${processId}`;
}

function getReferrerURL(): URL | null {
    return document.referrer ? new URL(document.referrer) : null;
}

export function getProcessListPathFromReferrer(processId: number): string {
    const referrer = getReferrerURL();

    if (referrer) {
        const referrerMatch = matchPath(referrer.pathname, { path: processURLPatternBase })?.params as IProcessURL || { processType: "process" };

        // Referrer is from a process list 
        if (referrerMatch.action === "List") {
            referrer.searchParams.append("highlightProcess", processId.toString());
            return referrer.toString();
        }
    }

    return getProcessPath(processId, false, DEFAULT_ENV_NAME, DEFAULT_AGENT_GROUP_NAME);
}